export default __webpack_public_path__ + "static/media/folder.c4a012a4.svg";